import './announcement-archive.scss'
import {Accordion} from 'devextreme-react/accordion';
import {Item, Toolbar} from 'devextreme-react/toolbar';
import {formatDate} from 'devextreme/localization';
import React, {useEffect, useRef} from 'react';
import {useAuth} from '../../../contexts/auth';
import {useTitle} from "../../../contexts/title";
import {useGetAnnouncements} from '../../../api/announcements';
import AnnouncementList from '../../../features/common/announcements/components/AnnouncementList';
import AnnouncementSearch from '../../../features/common/announcements/components/AnnouncementSearch';
import {LoadPagePanel} from '../../../components';

export default function AnnouncementArchivePage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Past Announcements')
	}, [pageTitle]);

	const { user } = useAuth();
	const announcements = useGetAnnouncements(true, user?.userName!);

	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	var d = new Date();
	d.setDate(1);
	var months = [];
	for (let i = 0; i < 12; i++) {

		months.push(monthNames[d.getMonth()] + ' ' + d.getFullYear());
		d.setMonth(d.getMonth() - 1);
	}

	function renderAnnouncementList(month: string) {
		var monthAnnouncements = announcements.data.filter(x => formatDate(x.startDate, "MMMM y") === month);
		return (
			monthAnnouncements.length > 0 ?
				<AnnouncementList announcements={monthAnnouncements} /> :
				<div>No announcements</div>
		)
	}

	function renderAnnouncementTitle(month: string) {
		var monthAnnouncements = announcements.data.filter(x => formatDate(x.startDate, "MMMM y") === month);
		return <>
			<div className='dx-accordion-item-title-caption'>{month}</div>
			<div className='dx-accordion-item-title-number'>
				{monthAnnouncements.length > 0 ? monthAnnouncements.length === 1 ? '1 announcement' :
					`${monthAnnouncements.length} announcements` : ''}
			</div>
		</>
	}

	const announcementContainerRef = useRef<HTMLDivElement>(null);
	const accordionRef = useRef<Accordion>(null);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<Toolbar className='button-toolbar'>
					<Item location='before'>
						<AnnouncementSearch elementToSearch={announcementContainerRef.current!}
							onMarkElement={(element) => {
								const item = element.closest(".dx-accordion-item");
								const parent = item?.parentNode;
								var index = Array.prototype.indexOf.call(parent?.children, item);
								if (index !== undefined) {
									accordionRef.current?.instance.expandItem(index);
								}
							}} />
					</Item>
				</Toolbar>
				<div ref={announcementContainerRef}>
					<Accordion
						ref={accordionRef}
						dataSource={months}
						itemRender={(item) => renderAnnouncementList(item)}
						itemTitleRender={(item) => renderAnnouncementTitle(item)}
						collapsible={true}
						multiple={true}
						deferRendering={false}
					/>
				</div>
			</div>
			<LoadPagePanel visible={announcements.isLoading} />
		</React.Fragment>
	)
} 
